// extracted by mini-css-extract-plugin
export var infoRow = "_v4-2";
export var labelContainer = "_v4-0";
export var rightInfo = "_v4-1";